import { createFileRoute } from '@tanstack/react-router';

import { requireRoute } from '@/router/guards';
import { laboratoriesScreen } from '@/ui/pages/Laboratories/laboratoriesScreen';

/** HS-869: the list is a `@smartsash/data-screen` definition — see `groups.index.tsx`. */
const LaboratoriesListScreen = laboratoriesScreen.ListScreen;

export const Route = createFileRoute('/_dashboard/laboratories/')({
  validateSearch: laboratoriesScreen.validateSearch,
  loaderDeps: laboratoriesScreen.loaderDeps,
  beforeLoad: requireRoute('/laboratories'),
  loader: laboratoriesScreen.loaderFor(),
  component: LaboratoriesListScreen,
});
